'use client'

import { parseAsInteger, useQueryState } from 'nuqs'
import { useMemo } from 'react'

import { DataTable } from '@/components/ui/data-table'

import { createColumns, type TableData } from './columns'

interface MasterTableProps {
  data: TableData[]
  isLoading: boolean
  totalCount?: number
  onEdit: (table: TableData) => void
  onDelete: (id: string) => void
  onAddGuest: (table: TableData) => void
}

export function MasterTable({
  data,
  isLoading,
  onEdit,
  onDelete,
  onAddGuest,
}: MasterTableProps) {
  const [page, setPage] = useQueryState(
    'page',
    parseAsInteger.withDefault(1).withOptions({ shallow: true }),
  )

  const columns = useMemo(
    () => createColumns(onEdit, onDelete, onAddGuest),
    [onEdit, onDelete, onAddGuest],
  )

  return (
    <DataTable
      columns={columns}
      data={data}
      pageSize={10}
      pageIndex={page - 1}
      onPageChange={(index) => setPage(index + 1)}
      isLoading={isLoading}
    />
  )
}
